import { actionFactory } from 'redux/factories';
import { types } from './types';

export const getJiraRoles = actionFactory(types.GET_JIRA_ROLES);
export const getJiraProjects = actionFactory(types.GET_JIRA_PROJECTS);
export const searchJiraUsers = actionFactory(types.SEARCH_JIRA_USERS);
export const updateJiraProjects = actionFactory(types.UPDATE_JIRA_PROJECTS);
